import DataGridLink from './DataGridLink';

export default DataGridLink;
